import {
  DrinksTabLink,
  DrinksTabLinkText,
  DrinksTabsWrapper,
} from 'features/menu/components/product-detail/product-customization/styled';
import {
  CATEGORY_LABEL_KEY,
  DrinkCategory,
} from 'features/menu/components/product-detail/product-customization/types';

import { t } from 'state/intl/translations';

interface ProductCustomizationDrinksTabsProps {
  categories: DrinkCategory[];
  activeTab: DrinkCategory;
  onTabPress: (tab: DrinkCategory) => void;
}

export const ProductCustomizationDrinksTabs = ({
  categories,
  activeTab,
  onTabPress,
}: ProductCustomizationDrinksTabsProps) => {
  return (
    <DrinksTabsWrapper testID="product-customization-drinks-tabs">
      {categories.map(category => (
        <DrinksTabLink
          key={`drinks-tab-${category}`}
          onPress={() => onTabPress(category)}
          minWidth={`${100 / categories.length}%`}
          active={activeTab === category}
        >
          <DrinksTabLinkText variant="headerThree" active={activeTab === category}>
            {t(CATEGORY_LABEL_KEY[category] as any)}
          </DrinksTabLinkText>
        </DrinksTabLink>
      ))}
    </DrinksTabsWrapper>
  );
};
